import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { AuthCard, AuthLayout } from "components/views/login/Shared"
import React, { useEffect } from "react"
import L10n from "lib/carrot-l10n"
import { TextLink } from "components/views/atoms/links/TextLink"
import { useHistory, useLocation } from "react-router"
import queryString from "query-string"
import { H1 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

function SentEmailAuthCard({ email }) {
  return (
    <AuthCard>
      <Spacer height={4} />
      <FlexRowCenter>
        <H1>{l`Check your inbox`}</H1>
      </FlexRowCenter>
      <Spacer height={1.25} />
      <Body color="black-80" align="tc">
        {l`We sent an activation link to `}
        {email}
        {l`. Please be sure to check your spam folder too.`}
      </Body>
      <Spacer height={1.5} />
      <Body color="black-80" align="tc">
        {l`If you have any trouble, we’re here to help at`}{" "}
        <TextLink to="mailto:support@get-carrot.com">{l`support@get-carrot.com`}</TextLink>
      </Body>
      <Spacer height={3} />
    </AuthCard>
  )
}

export default function SignUpSuccessPage() {
  const location = useLocation()
  const history = useHistory()
  const { email } = queryString.parse(location.search)

  useEffect(() => {
    if (!email) {
      history.push("/signup")
    }
  }, [])

  return (
    <AuthLayout title="Check your inbox">
      <SentEmailAuthCard {...{ email }} />
    </AuthLayout>
  )
}
